<template>
    <div class="w-full h-full flex flex-col">
        <!-- 导航栏 -->
        <NavigateBar />
        <div class="flex-1 w-full overflow-hidden flex items-stretch">
            <!-- 菜单栏 -->
            <SideBar />
            <div class="flex-1 h-full overflow-hidden flex flex-col">
                <!-- 面包屑 -->
                <Crumb v-if="$route.path !== '/index'" />
                <!-- 主体内容 -->
                <div class="flex-1 overflow-auto">
                    <router-view class="flex flex-col w-full h-full overflow-auto" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavigateBar from "./components/NavigateBar.vue";
import SideBar from "./components/SideBar/index.vue";
import Crumb from './components/Crumb.vue';

export default {
    components: {
        NavigateBar,
        SideBar,
        Crumb
    },
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped></style>
